import { Component, inject, model, OnInit } from '@angular/core';
import { NavigationModuleIconComponent } from '@core/navigation/components/navigation-module-icon/navigation-module-icon.component';
import { Navigation } from '@core/navigation/navigation.model';
import { NotificationsService } from '@core/notifications/notifications.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CollapseComponent } from "@shared/components/collapse/collapse.component";
import { TooltipDirective } from "@shared/directives/tooltip/tooltip.directive";
import { ProcessToastComponent } from "../process-toast/process-toast.component";

@Component({
  selector: 'app-processes-status',
  imports: [CollapseComponent, FontAwesomeModule, ProcessToastComponent, TooltipDirective, NavigationModuleIconComponent],
  templateUrl: './processes-status.component.html',
  styleUrl: './processes-status.component.scss',
})
export class ProcessesStatusComponent implements OnInit{

    Navigation = Navigation;

    notificationsService = inject(NotificationsService);

    state = model<'collapsed'|'expanded'>('collapsed');
    
    processJobs = this.notificationsService.processNotifications;

    ngOnInit(): void {
        this.notificationsService.processNotifications$.subscribe({
            next: (processes) => {
                if(processes.length > 0){
                    this.state.set('expanded');
                }
                else{
                    this.state.set('collapsed');
                }
            }
        })
    }

}
